import SchoolListPage from './SchoolListPage';

export default SchoolListPage;
